import Metaballs from '../lib/metaballs';

var canvas;
var gl;
var realToCSSPixels = window.devicePixelRatio;
var displayWidth;
var displayHeight;
var createdMetaballs = [];

// var assetsIndexToLoad = 0;
// var assetsToLoad = [
//   { path: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/t-183/', src: 'noise3.png', name: 'noise3', type: 'texture' },
// ];
// var assets = {};

// window.onload = preloadAssets;

// function preloadAssets() {
//   function checkIfAllAssetsAreLoaded() {
//     if (assetsIndexToLoad < assetsToLoad.length) {
//       loadAssetIndex(assetsIndexToLoad);
//     } else {
initialize();
//     }
//   }

//   function loadAssetIndex(index) {
//     var objectToLoad = assetsToLoad[index];

//     switch (objectToLoad.type) {
//       case 'texture':
//         var image = new Image();
//         image.onload = function () {
//           assets[objectToLoad.name] = this;
//           assetsIndexToLoad++;
//           checkIfAllAssetsAreLoaded();
//         };
//         image.crossOrigin = '';
//         image.src = objectToLoad.path + objectToLoad.src;
//         break;
//     }
//   }

//   loadAssetIndex(assetsIndexToLoad);
// }

function initialize() {
  canvas = document.getElementById('metaball-canvas');
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  var glConfig = {
    premultipliedAlpha: true,
    antialias: true,
    depth: true,
    alpha: true,
  };

  gl = canvas.getContext('webgl', glConfig) || canvas.getContext('experimental-webgl', glConfig);

  if (!gl) {
    console.error('cannot find gl', gl);
    return;
  }
  displayWidth = Math.floor(gl.canvas.clientWidth);
  displayHeight = Math.floor(gl.canvas.clientHeight);

  var minSpeed = 0.2;
  var maxSpeed = 3;
  var minMultiplierArcX = -0.5;
  var maxMultiplierArcX = 2;
  var minMultiplierArcY = -0.5;
  var maxMultiplierArcY = 2;
  var scale = 1.0;

  var metaballsGroup1 = {
    metaballs: [
      {
        centerOffsetX: -900 * scale,
        centerOffsetY: 450 * scale,
        radius: 200 * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      },
      {
        centerOffsetX: -800 * scale,
        centerOffsetY: 500 * scale,
        radius: 60 * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      },
      {
        centerOffsetX: -300 * scale,
        centerOffsetY: 420 * scale,
        radius: 64 * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      },
      {
        centerOffsetX: -580 * scale,
        centerOffsetY: 400 * scale,
        radius: 160 * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      },
      {
        centerOffsetX: -780 * scale,
        centerOffsetY: 50 * scale,
        radius: 100 * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      },
    ],
    texture: generateGradientTexture(
      [
        { color: '#78AEF5', stop: 0 },
        { color: '#A765D3', stop: 0.1 },
        { color: '#DE7E5A', stop: 0.3 },
      ],
      false,
      false
    ),
  };
  function randomNumber(min, max) {
    return Math.random() * (max - min) + min;
  }

  var metaballsGroup2 = {
    metaballs: Array(10)
      .fill({})
      .map(() => ({
        centerOffsetX: randomNumber(400, 900) * scale,
        centerOffsetY: randomNumber(200, 600) * scale,
        radius: randomNumber(20, 150) * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      })),

    texture: generateGradientTexture(
      [
        { color: '#DE887C', stop: 0.7 },
        { color: '#A865C9', stop: 0.8 },
        { color: '#6FA1F3', stop: 0.9 },
      ],
      false,
      false
    ),
  };

  var metaballsGroup3 = {
    metaballs: Array(10)
      .fill({})
      .map(() => ({
        centerOffsetX: randomNumber(300, 900) * scale,
        centerOffsetY: randomNumber(-200, -600) * scale,
        radius: randomNumber(20, 150) * scale,
        speed: getRandomFloat(minSpeed, maxSpeed),
        t: Math.random() * 200,
        arcMultiplierX: getRandomFloat(minMultiplierArcX, maxMultiplierArcX),
        arcMultiplierY: getRandomFloat(minMultiplierArcY, maxMultiplierArcY),
      })),
    texture: generateGradientTexture(
      [
        { color: '#9BBCF7', stop: 0.7 },
        { color: '#B792E4', stop: 0.8 },
        { color: '#E7AE9A', stop: 0.9 },
      ],
      false,
      false
    ),
  };

  createdMetaballs.push(new Metaballs(gl, metaballsGroup1, { width: displayWidth, height: displayHeight }));

  createdMetaballs.push(new Metaballs(gl, metaballsGroup2, { width: displayWidth, height: displayHeight }));
  createdMetaballs.push(new Metaballs(gl, metaballsGroup3, { width: displayWidth, height: displayHeight }));

  for (var i = 0; i < createdMetaballs.length; i++) {
    setTimeout(createdMetaballs[i].fadeIn, i * 200);
  }
  window.addEventListener('resize', onWindowResize);
  window.addEventListener('mousemove', onWindowMouseMove);

  resizeGL(gl);

  const step = () => {
    createdMetaballs.forEach(function (metaball) {
      metaball.updateSimulation();
    });
    requestAnimationFrame(step);
  };
  step();
}

function generateGradientTexture(colors, vertical, debug) {
  colors = colors || [
    { color: '#000000', stop: 0.0 },
    { color: '#FFF000', stop: 0.5 },
    { color: '#642054', stop: 1.0 },
  ];
  vertical = vertical !== undefined ? vertical : false;

  var size = 512;

  // create canvas
  var textureCanvas = document.createElement('canvas');
  textureCanvas.width = size;
  textureCanvas.height = size;

  if (debug == true) {
    textureCanvas.style.position = 'absolute';
    textureCanvas.style.top = '0px';
    textureCanvas.style.left = '0px';
    document.body.appendChild(textureCanvas);
  }

  // get context
  var context = textureCanvas.getContext('2d');

  // draw gradient
  context.rect(0, 0, size, size);

  var grd = vertical ? context.createLinearGradient(0, size, 0, 0) : context.createLinearGradient(0, 0, size, 0);
  for (var i = 0; i < colors.length; i++) {
    grd.addColorStop(colors[i].stop, colors[i].color);
  }
  context.fillStyle = grd;
  context.fillRect(0, 0, size, size);

  return textureCanvas;
}

function getRandomFloat(min, max) {
  return Math.random() * (max - min) + min;
}

function onWindowResize() {
  canvas.width = canvas.clientWidth;
  canvas.height = canvas.clientHeight;

  resizeGL(gl);
  gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
}

function onWindowMouseMove(event) {
  createdMetaballs.forEach(function (metaball) {
    metaball.handleMouseMove(event.clientX, event.clientY);
  });
}

function resizeGL(gl) {
  // realToCSSPixels = window.devicePixelRatio;

  // Lookup the size the browser is displaying the canvas in CSS pixels
  // and compute a size needed to make our drawingbuffer match it in
  // device pixels.
  displayWidth = Math.floor(gl.canvas.clientWidth /** realToCSSPixels*/);
  displayHeight = Math.floor(gl.canvas.clientHeight /** realToCSSPixels*/);

  // Check if the canvas is not the same size.
  if (gl.canvas.width !== displayWidth || gl.canvas.height !== displayHeight) {
    // Make the canvas the same size
    gl.canvas.width = displayWidth;
    gl.canvas.height = displayHeight;
  }

  console.log(displayWidth, '___________>>> ', gl.canvas.width);

  gl.viewport(0, 0, displayWidth, displayHeight);

  createdMetaballs.forEach(function (metaball) {
    metaball.handleResize(displayWidth, displayHeight);
  });
}

setTimeout(() => {
  document.querySelector('.blobs_canvas').style.visibility = 'visible';
}, 0);
